/** KYC / proposal document uploads (jpg, png, pdf). */
export const MAX_DOCUMENT_UPLOAD_MB = 5;
export const MAX_DOCUMENT_UPLOAD_BYTES =
  MAX_DOCUMENT_UPLOAD_MB * 1024 * 1024;

/**
 * @param {File|Blob|null|undefined} file
 * @param {string} [fieldLabel] - Optional label prefix (e.g. "Income Proof") for UI copy.
 * @returns {string|null} Error message if over limit, otherwise null.
 */
export function getDocumentUploadOverSizeError(file, fieldLabel) {
  if (!file || typeof file !== "object") return null;
  if (typeof Blob !== "undefined" && !(file instanceof Blob)) return null;
  const raw = file.size;
  const size = typeof raw === "number" && Number.isFinite(raw) ? raw : NaN;
  const prefix =
    fieldLabel && String(fieldLabel).trim() ? `${String(fieldLabel).trim()}: ` : "";
  if (!Number.isFinite(size) || size < 0) {
    return `${prefix}File size must not exceed ${MAX_DOCUMENT_UPLOAD_MB} MB.`;
  }
  if (size > MAX_DOCUMENT_UPLOAD_BYTES) {
    const approxMb = (size / (1024 * 1024)).toFixed(1);
    return `${prefix}This file is about ${approxMb} MB. Maximum allowed is ${MAX_DOCUMENT_UPLOAD_MB} MB.`;
  }
  return null;
}
